var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12478_6777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0.242188C15.9951 0.249083 11.129 4.79898 11.1216 10.4137V17.6476C11.1216 17.8396 11.7473 17.6476 12.2094 17.6476H15.4729C15.9351 17.6476 16.1424 17.9076 16.1424 17.6476V10.4137C16.1424 7.38882 18.7649 4.93673 22 4.93673C25.235 4.93673 27.8576 7.38882 27.8576 10.4137V13.5434C27.8576 13.9756 28.2322 14.3259 28.6944 14.3259H32.0415C32.5037 14.3259 32.8783 13.9756 32.8783 13.5434V10.4137C32.871 4.79898 28.0048 0.249083 22 0.242188Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2496 17.6484H32.7504C35.2243 17.6484 37.2297 19.7357 37.2297 22.3106V39.0943C37.2297 41.6692 35.2243 43.7565 32.7504 43.7565H11.2496C8.77572 43.7565 6.77026 41.6692 6.77026 39.0944V22.3107C6.77026 19.7357 8.77572 17.6484 11.2496 17.6484Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3513 28.267C26.3614 26.017 24.4215 24.1853 22.0183 24.1758C19.6152 24.1663 17.6588 25.9826 17.6487 28.2326C17.6416 29.7879 18.581 31.2111 20.0697 31.901L19.3978 36.3009C19.3305 36.7465 19.6618 37.1588 20.1377 37.2218C20.178 37.2271 20.2187 37.2298 20.2594 37.2298H23.7405C24.2211 37.2342 24.6145 36.8731 24.6193 36.4231C24.6197 36.3822 24.6168 36.3414 24.6107 36.3009L23.9388 31.901C25.4096 31.2114 26.342 29.8069 26.3513 28.267Z",
    fill: "#455A64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12478_6777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.5135,
    height: 43.5135,
    fill: "white",
    transform: "translate(0.243225 0.242188)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lockIcon.a1f634237849cc11e91aa99f0b31f3c7.svg";